import SmsDocsFeature from '../../features/docs/sms-feature';

export default function SmsDocsPage() {
  return <SmsDocsFeature />;
}
